<template>
  <div>
      <div class="container-fluid">
        <div class="page-header">
          <div class="row">
            <div class="col-sm-6">
              <h3>{{$t("advertisements")}}</h3>
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>{{$t("general")}}</a></li>
                <li class="breadcrumb-item active">{{$t("advertisement_management")}}</li>
              </ol>
            </div>
            <div class="col-sm-6">
              <!-- Bookmark Start-->
              <div class="bookmark">
                <ul>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                  <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top" title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                  <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                    <form class="form-inline search-form">
                      <div class="form-group form-control-search">
                        <input type="text" :placeholder="$t('search') + '...'">
                      </div>
                    </form>
                  </li>
                </ul>
              </div>
              <!-- Bookmark Ends-->
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid starts-->
      <div class="container-fluid">
        <div class="col-md-12 p-0 project-list">
          <div class="card">
            <div class="row">
              <div class="col-md-6 p-0">
                <div class="mb-2">
                  <input class="form-control" type="text" v-model="search" @change="fetchAdvertisements(true)" :placeholder="$t('search') + '...'">
                </div>
              </div>
              <div class="col-md-6 p-0">                    
                <div class="form-group mb-0 me-0"></div>
                <a class="btn btn-primary-light" @click="$router.push('/create-advertisement')"> <plus-square-icon class="custom-class"></plus-square-icon>{{$t("CREATE_NEW_ADVERTISEMENT")}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
                <div class="card">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">{{$t("active")}}</th>
                          <th v-show="$rights.includes('TENANT_INDEPENDENCE')" scope="col">{{ $t("tenant") }} </th>
                          <th @click="sort = 'name', order = !order,page = 1, fetchAdvertisements()" scope="col">{{$t("name")}} <v-icon size="16px" v-show="sort == 'name' && order" >fas fa-chevron-down</v-icon><v-icon size="16px" v-show="sort == 'name' && !order" >fas fa-chevron-up</v-icon></th>
                          <th @click="sort = 'startDate', order = !order,page = 1, fetchAdvertisements()" scope="col">{{$t("startdate")}} <v-icon size="16px" v-show="sort == 'startDate' && order" >fas fa-chevron-down</v-icon><v-icon size="16px" v-show="sort == 'startDate' && !order" >fas fa-chevron-up</v-icon></th>
                          <th @click="sort = 'endDate', order = !order,page = 1, fetchAdvertisements()" scope="col">{{$t("enddate")}} <v-icon size="16px" v-show="sort == 'endDate' && order" >fas fa-chevron-down</v-icon><v-icon size="16px" v-show="sort == 'endDate' && !order" >fas fa-chevron-up</v-icon></th>
                          <th scope="col">{{$t("app")}}</th>
                          <th scope="col">{{$t("placement")}}</th>
                          <th scope="col">{{$t("actions")}}</th>
                        </tr>
                      </thead>
                      <tbody v-if="advertisements.length > 0">
                        <tr v-for="advertisement in advertisements" :key="advertisement.id">
                          <td><v-switch color="primary" :disabled="requested" v-model="advertisement.active" @change="toggleAdvertisementActive(advertisement.id, advertisement.active)" hide-details></v-switch></td>
                          <td v-show="$rights.includes('TENANT_INDEPENDENCE')">{{advertisement.tenant.name}}</td>
                          <td>{{advertisement.name}}</td>
                          <td>{{advertisement.startDate == null ? null :$formatDateTime(advertisement.startDate)}}</td>
                          <td>{{advertisement.endDate == null ? null  :$formatDateTime(advertisement.endDate)}}</td>
                          <td>{{advertisement.placement.app.name}}</td>
                          <td><span class="badge badge-info" style="font-size: 10px">{{advertisement.placement.namesMap[$locale]}}</span></td>
                          <td>
                              <!-- Edit Button -->
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <button class="btn btn-light mr-2" v-on="on" @click="$router.push('/edit-advertisement?advertisementId=' + advertisement.id)">
                                  <edit-icon size="16"></edit-icon></button>
                                </template>
                                <span>{{ $t("edit_advertisement") }}</span><br>
                              </v-tooltip>
                              <!-- Copy Button -->
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <button class="btn btn-secondary mr-2" v-on="on" @click="openCopyPopup(advertisement)">
                                  <copy-icon size="16"></copy-icon></button>
                                </template>
                                <span>{{ $t("copy_advertisement") }}</span><br>
                              </v-tooltip>
                              <!-- Delete Button -->
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <button v-if="$rights.includes('DELETE_ADVERTISEMENTS')" v-on="on" class="btn btn-danger" @click="openDeletePopup(advertisement)">
                                  <trash-icon size="16"></trash-icon></button>
                                </template>
                                <span>{{ $t("delete_advertisement") }}</span><br>
                              </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <td colspan="5">{{ $t("no_entries") }}</td>
                      </tbody>
                    </table>
                  </div>
                </div>
          </div>
        </div>
      </div>
      <div style="position:absolute; bottom: 100px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
      <!-- Container-fluid Ends-->

      <!-- Copy Modal -->
      <div class="modal fade show" v-show="showCopyPopup" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{$t("copy_advertisement")}}: {{ copyingAdName }}</h5>
              <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title="" title="" @click="(showCopyPopup = false)"></button>
            </div>
            <div class="modal-body">
              <p>{{ $t("copy_ad_hint") }}</p>
              <label class="form-label" for="adName">{{$t("designation_new_ad")}}</label>
              <input class="form-control" id="adName" type="text" v-model="copyAd.name" @keypress.enter="copyAdvertisement()">
            </div>
            <div class="modal-footer">
              <button @click="(showCopyPopup = false)" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{$t("cancel")}}</button>
              <button @click="copyAdvertisement()" class="btn btn-primary" type="button" data-bs-original-title="" title="">{{$t("save")}}</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Copy Modal -->
      <div class="modal fade show" v-show="showDeletePopup" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{$t("delete_advertisement")}}</h5>
              <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title="" title="" @click="(showDeletePopup = false)"></button>
            </div>
            <div class="modal-body">
              <p>{{ $t("confirm_delete_advertisement", {name: deleteAdvertisement.name}) }}</p>
            </div>
            <div class="modal-footer">
              <button @click="(showDeletePopup = false)" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{$t("cancel")}}</button>
              <button @click="deleteAd()" class="btn btn-danger" type="button" data-bs-original-title="" title="">{{$t("delete")}}</button>
            </div>
          </div>
        </div>
      </div>
    
  </div>
</template>

<script>

import pagination from './custom/pagination.vue'
import { MapPinIcon,PlusSquareIcon,ClipboardIcon,FileTextIcon,TrashIcon, EditIcon, CopyIcon } from 'vue-feather-icons'

export default {

  components: {
    MapPinIcon,
    PlusSquareIcon,
    ClipboardIcon,
    FileTextIcon,
    TrashIcon,
    EditIcon,
    CopyIcon
  },

  data() {
    return {
      page: 1,
      totalPages: 1,
      ElementPerPage: 20,
      sort: 'createdAt',
      order: true,
      requested:false,
      routes: {
        advertisements: "/api/advertisement",
        filter: "/api/advertisements/search/"
      },
      search: "",
      convertedTenants: [],
      tenantFilter: null,
      showCopyPopup: false,
      showDeletePopup: false,
      copyingAdName: "",
      copyAd: {
        advertisementId: 0,
        name: "",
      },
      deleteAdvertisement:{
        id: 0,
        name: "",
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      advertisements: [],
      roles: [],
      menu: false,
      createmode: true,

      // Personal Data
      me: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  mounted() {
    this.fetchAdvertisements();
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
          setTimeout(() => {
            var _this = this;
            if(this.page  < this.totalPages){
                    this.page++;
                    this.$axios
                        .get(this.routes.advertisements, {
                          params: {
                            search: this.search,
                            sort: this.sort,
                            order: this.order ? "ASC":"DESC",
                            page: this.page -1,
                            size: this.ElementPerPage
                          }
                        })
                        .then(function (response) {
                          if(response.data.content.length >= 1) {
                                response.data.content.forEach(item => _this.advertisements.push(item));
                                _this.totalPages = response.data.totalPages;
                            }
                        })
                        .catch(this.onError);
                }
            }, 500);
        }
    },
    toggleAdvertisementActive(advertisementId, active){
      var _this = this;
      this.requested = true;
      this.$axios
        .patch(this.routes.advertisements + "/" + advertisementId + "/active/" + active)
        .then(function (response) {
          if(_this.$changeAmountOfActiveAds != null){
            _this.$changeAmountOfActiveAds(active ? 1 : -1);
          }
        })
        .catch(this.onError)
        .finally(() => {
          _this.requested = false;
        });
    },
    previousPage() {
      this.page = this.page - 1;
      this.fetchAdvertisements();
    },
    nextPage() {
      this.page = this.page + 1;
      this.fetchAdvertisements();
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null
      ) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    openCopyPopup(ad){
      this.copyAd.advertisementId = ad.id;
      this.copyingAdName = ad.name;  
      this.showCopyPopup = true;
    },
    copyAdvertisement(){
      var _this = this;
      progressIndicator.hidden = false;
      this.$axios
        .post("/api/advertisement/copy", this.copyAd)
        .then(function (response) {
          _this.copyAd.name = "";
          _this.$noty.success(_this.$t("ad_copied"));
          _this.fetchAdvertisements(true);
          _this.showCopyPopup = false;
        })
        .catch(this.onError)
        .finally(() => {
          this.$finalize();
        });
    },
    openDeletePopup(ad){
      this.deleteAdvertisement.id = ad.id;
      this.deleteAdvertisement.name = ad.name;  
      this.showDeletePopup = true;
    },
    deleteAd(){
      var _this = this;
      progressIndicator.hidden = false;
      this.$axios
        .delete("/api/advertisement/" + this.deleteAdvertisement.id)
        .then(function (response) {
          _this.deleteAdvertisement.name = "";
          _this.$noty.success(_this.$t("advertisement_deleted"));
          _this.fetchAdvertisements(true);
          _this.showDeletePopup = false;
        })
        .catch(this.onError)
        .finally(() => {
          this.$finalize();
        });
    },
    fetchAdvertisements(resetPage = false) {
      if(resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get(this.routes.advertisements, {
          params: {
            search: _this.search,
            sort: _this.sort,
            order: _this.order ? "ASC":"DESC",
            page: _this.page -1,
            size: _this.ElementPerPage
          }
        })
        .then(function (response) {
          _this.advertisements = response.data.content;
          _this.totalPages = response.data.totalPages;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    updatePage() {
      this.fetchTenants();
    },

    tableRowClicked(tenantId){
      if(this.$rights.includes('EDIT_CUSTOMERS') || this.$rights.includes('TENANT_INDEPENDENCE')){
        this.$router.push('/edit-tenant?tenantId=' + tenantId)
      }
    },
    dateToString(date) {
      const stringValue = date.toISOString();

      const dotIndex = stringValue.indexOf('.');

      if (dotIndex < 0) {
          return stringValue;
      }

      return stringValue.slice(0, dotIndex);
    },
    getJsonOptions() {
      const options = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      return options;
    },
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>

